import React, { useEffect, useState } from "react";
import "./cssservices.css";
import { FaServicestack } from "react-icons/fa";

import { useTranslation } from "react-i18next";
import axios from "axios";
import { baseURL } from "../../App";
import SkeletonLoader from "../Skeleton/SkeletonLoader";

const Services = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]); // Added state to hold services
  const API_URL = `${baseURL}/api/services`;

  // error handling and loading state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch services from the backend
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await axios.get(API_URL);
        // console.log(response.data);
        setServices(response.data); // Assuming response.data is an array of services
      } catch (error) {
        setError("Error fetching services");
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [API_URL]);

  if (loading) {
    return (
      <section id="services">
        <h5>{t("services.offer")}</h5>
        <h2>{t("services.service_title")}</h2>
        <SkeletonLoader type="grid" count={3} />
      </section>
    );
  }
  if (error) return <p>{error}</p>;

  return (
    <section id="services">
      <h5>{t("services.offer")}</h5>
      <h2>{t("services.service_title")}</h2>
      <div className="container services_container">
        {services.map((service) => (
          <article className="service item_scale" key={service._id}>
            <div className="service_head">
              <h3>
                {i18n.language === "en" ? service.titleEn : service.titleFr}{" "}
              </h3>
            </div>
            <ul className="service_list">
              {service.items.map((item) => (
                <li key={item.id}>
                  <div>
                    <FaServicestack className="service_list-icon" />
                  </div>
                  <p>
                    {i18n.language === "en"
                      ? item.descriptionEn
                      : item.descriptionFr}
                  </p>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
    // <section id="services">
    //   <h5>{t("services.offer")}</h5>
    //   <h2>{t("services.service_title")}</h2>
    //   <div className="container services_container">
    //     <article className="service item_scale">
    //       <div className="service_head">
    //         <h3>{t("services.education")}</h3>
    //       </div>
    //       <ul className="service_list">
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.math_teach")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.security_computer")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p> {t("services.sytem_admin")}</p>
    //         </li>
    //       </ul>
    //     </article>

    //     <article className="service item_scale">
    //       <div className="service_head">
    //         <h3>{t("services.skill1")}</h3>
    //       </div>
    //       <ul className="service_list">
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.portfolio_development")} </p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.web_app_dev")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.restaurant_menu")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.Java_development")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.front-back_end")}</p>
    //         </li>
    //       </ul>
    //     </article>

    //     <article className="service item_scale">
    //       <div className="service_head">
    //         <h3>{t("services.other_services")}</h3>
    //       </div>
    //       <ul className="service_list">
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.coder")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.M365")}</p>
    //         </li>
    //         <li>
    //           <FaServicestack className="service_list-icon" />
    //           <p>{t("services.graphic_design")}</p>
    //         </li>
    //       </ul>
    //     </article>
    //   </div>
    // </section>
  );
};

export default Services;
